// extracted by mini-css-extract-plugin
module.exports = {"i1orwq5g":"i1orwq5g","h1l2dj7v":"h1l2dj7v"};